export class LanguageItem {
    id: number = -2;
    key: string = '';
    textString: string = '...';
    group: string = '';
    languageId: number = -1;
}
